import styled from 'styled-components';
import { AccordionDetails as MuiAccordionDetails } from '@mui/material';

const AccordionDetails = styled(MuiAccordionDetails)`
  background-color: ${({ theme }) => theme.palette.common.gray10};
  border: 1px solid ${({ theme }) => theme.palette.common.gray13};
  border-radius: 0 0 8px 8px;
  padding: 24px;
`;

export default AccordionDetails;
